import UtilitiesService from '../../../services/api/utilitiesService';

export const filterList = (lists, listCategory) => {
  return lists.filter((list) => list.category === listCategory);
};

export const getLists = ({
  set_churchMinistries,
  set_experienceVolunteersRoles,
  set_experienceVolunteersSections,
  set_groupCategories,
  set_leaderCategories,
  set_data,
}) => {
  UtilitiesService.getList()
    .then((response) => {
      if (response.data.success) {
        set_churchMinistries?.(filterList(response.data.lists, 'churchMinistries'));
        set_experienceVolunteersRoles?.(
          filterList(response.data.lists, 'experienceVolunteersRoles')
        );
        set_groupCategories?.(
          filterList(response.data.lists, 'groupCategories')?.map((item) => item.key)
        );
        set_leaderCategories?.(
          filterList(response.data.lists, 'leaderCategories')?.map((item) => item.key)
        );
        set_experienceVolunteersSections?.(
          filterList(response.data.lists, 'experienceVolunteersSections')
        );
        set_data?.(filterList(response.data.lists, 'data'));
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
